/* ============================================================
   THREE PINES ROOFING — THEME JS v2.0
   Cafe Racer · Classic Americana · Aspirational Luxury
   ============================================================ */

(function() {
  'use strict';

  /* ── Header Scroll Effect ── */
  const header = document.querySelector('.tp-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('tp-header--scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Hero BG Ken Burns ── */
  const heroBg = document.querySelector('.tp-hero__bg');
  if (heroBg) {
    setTimeout(() => heroBg.classList.add('loaded'), 100);
  }

  /* ── Sticky CTA Bar ── */
  const stickyCta = document.querySelector('.tp-sticky-cta');
  if (stickyCta) {
    const heroSection = document.querySelector('.tp-hero');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        stickyCta.classList.toggle('visible', !e.isIntersecting);
      });
    }, { threshold: 0.1 });
    if (heroSection) observer.observe(heroSection);
  }

  /* ── Fade-Up Animations ── */
  const fadeEls = document.querySelectorAll('.tp-fade-up');
  if (fadeEls.length) {
    const fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, (entry.target.dataset.delay || 0) * 1);
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach((el, i) => {
      el.dataset.delay = i * 80;
      fadeObserver.observe(el);
    });
  }

  /* ── Multi-Step Funnel Form ── */
  const funnel = document.querySelector('.tp-funnel');
  if (funnel) {
    const panes = funnel.querySelectorAll('.tp-funnel__pane');
    const dots = funnel.querySelectorAll('.tp-funnel__step-dot');
    const progressBar = funnel.querySelector('.tp-funnel__progress-bar');
    const backBtn = funnel.querySelector('.tp-funnel__back');
    const successPane = funnel.querySelector('.tp-funnel__success');
    let currentStep = 0;
    const totalSteps = panes.length;

    function updateProgress() {
      const pct = ((currentStep + 1) / totalSteps) * 100;
      if (progressBar) progressBar.style.width = pct + '%';
      dots.forEach((dot, i) => {
        dot.classList.remove('active', 'done');
        if (i === currentStep) dot.classList.add('active');
        else if (i < currentStep) dot.classList.add('done');
      });
      if (backBtn) backBtn.classList.toggle('visible', currentStep > 0);
    }

    function goToStep(step) {
      panes[currentStep].classList.remove('active');
      currentStep = step;
      if (currentStep < totalSteps) {
        panes[currentStep].classList.add('active');
        updateProgress();
        // Scroll funnel into view on mobile
        if (window.innerWidth < 768) {
          funnel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else {
        // Show success
        panes.forEach(p => p.classList.remove('active'));
        if (successPane) {
          successPane.classList.add('active');
          if (progressBar) progressBar.style.width = '100%';
          dots.forEach(d => d.classList.add('done'));
        }
      }
    }

    // Next buttons
    funnel.querySelectorAll('[data-funnel-next]').forEach(btn => {
      btn.addEventListener('click', () => {
        const pane = panes[currentStep];
        // Validate required fields
        const required = pane.querySelectorAll('[required]');
        let valid = true;
        required.forEach(field => {
          if (!field.value.trim()) {
            field.style.borderColor = '#e05252';
            setTimeout(() => field.style.borderColor = '', 2000);
            valid = false;
          }
        });
        if (!valid) return;
        goToStep(currentStep + 1);
      });
    });

    // Option selection (qualifying questions)
    funnel.querySelectorAll('.tp-option').forEach(opt => {
      opt.addEventListener('click', () => {
        const group = opt.closest('.tp-options');
        if (group) {
          group.querySelectorAll('.tp-option').forEach(o => o.classList.remove('selected'));
        }
        opt.classList.add('selected');
        // Store value
        const input = opt.closest('.tp-funnel__pane').querySelector('input[type="hidden"]');
        if (input) input.value = opt.dataset.value || opt.textContent.trim();
        // Auto-advance after short delay for UX
        setTimeout(() => {
          const nextBtn = opt.closest('.tp-funnel__pane').querySelector('[data-funnel-next]');
          if (nextBtn) nextBtn.click();
        }, 350);
      });
    });

    // Back button
    if (backBtn) {
      backBtn.addEventListener('click', () => {
        if (currentStep > 0) goToStep(currentStep - 1);
      });
    }

    // Form submission (final step)
    const submitBtn = funnel.querySelector('[data-funnel-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const pane = panes[currentStep];
        const required = pane.querySelectorAll('[required]');
        let valid = true;
        required.forEach(field => {
          if (!field.value.trim()) {
            field.style.borderColor = '#e05252';
            setTimeout(() => field.style.borderColor = '', 2000);
            valid = false;
          }
        });
        if (!valid) return;

        // Collect all form data
        const formData = {};
        funnel.querySelectorAll('input:not([type="hidden"]), select, textarea').forEach(field => {
          if (field.name || field.id) {
            formData[field.name || field.id] = field.value;
          }
        });
        funnel.querySelectorAll('input[type="hidden"]').forEach(field => {
          if (field.name) formData[field.name] = field.value;
        });

        // Submit to Shopify contact form or custom endpoint
        const form = funnel.querySelector('form');
        if (form) {
          form.submit();
        } else {
          goToStep(totalSteps);
        }
      });
    }

    // Init
    updateProgress();
  }

  /* ── Smooth Scroll ── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = 80;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* ── Mobile Nav Toggle ── */
  const mobileToggle = document.querySelector('.tp-mobile-toggle');
  const mobileNav = document.querySelector('.tp-mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      mobileToggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  /* ── Counter Animation ── */
  const counters = document.querySelectorAll('[data-count]');
  if (counters.length) {
    const countObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseInt(el.dataset.count, 10);
          const suffix = el.dataset.suffix || '';
          const duration = 1800;
          const start = performance.now();
          const animate = (now) => {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.round(eased * target) + suffix;
            if (progress < 1) requestAnimationFrame(animate);
          };
          requestAnimationFrame(animate);
          countObserver.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(c => countObserver.observe(c));
  }

})();
